<div class="tags-wrapper">
	<div id="tagsList" class="tags-cloud">
        <div class="input-group" style="width: 100%">
            <input type="text" id="searchInput" (focus)="fieldFocused()"  autocomplete="off" (keydown)="checkKeyDown($event)" class="form-control" [(ngModel)]="searchText" (input)="search()" [required]="required" [disabled]="disabled" (blur)="check()" placeholder="{{placeholder || stdplaceholder}}"  [ngClass]="{'is-invalid': (selectedTags == null || selectedTags == '') && required}" uib-popover-html="warningMsg" popover-placement="bottom" popover-trigger="'focus'"/> 
        </div>
    </div>
    <ul id="suggestions" class="suggestions-list2">
		<li *ngFor="let suggestion of suggestions;let i = index" class="blockSpan" (click)="addToSelectedTags(i)" [ngClass]="{'active' : selectedIndex===i}">{{suggestion.DisplayValue}}</li>
    </ul>
</div>